import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGoogle } from '@fortawesome/free-brands-svg-icons'
import logo from '../assets/img/logo.jpg';

export default class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      user,
      signOut,
      signInWithGoogle,
    } = this.props;
    console.log(signInWithGoogle);
    return (
      <div>
        {user && (
          <div className="login-page">
            <div className="container">
              <div className="row">
                <div className="col-sm-8 col-md-6 col-lg-5 mx-auto">
                  <div className="card card-signin my-5">
                    <div className="card-body">
                      <img src={logo} alt="logo" className="d-block mx-auto" height="150" />
                      <p className="card-title text-center">Hello, {user.displayName}</p>
                      <button className="btn btn-lg btn-google btn-block text-uppercase" onClick={signOut}>Sign out</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!user && (
          <div className="login-page">
            <div className="container">
              <div className="row">
                <div className="col-sm-8 col-md-6 col-lg-5 mx-auto">
                  <div className="card card-signin my-5">
                    <div className="card-body">
                      <img src={logo} alt="logo" className="d-block mx-auto" height="150" />
                      <h5 className="card-title text-center"><b>Welcome to Wiwer Admin</b></h5>
                      <form className="form-signin">
                        {/* <div class="form-label-group">
                                            <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus />
                                            <label for="inputEmail">Email address</label>
                                        </div> */}

                        {/* <div class="form-label-group">
                                            <input type="password" id="inputPassword" class="form-control" placeholder="Password" required />
                                            <label for="inputPassword">Password</label>
                                        </div> */}

                        {/* <div class="custom-control custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input" id="customCheck1" />
                                            <label class="custom-control-label" for="customCheck1">Remember password</label>
                                        </div> */}
                        {/* <button class="btn btn-lg btn-block text-uppercase" type="submit">Sign in</button> */}
                        {/* <hr class="my-4" /> */}
                        <div onClick={signInWithGoogle} className="btn btn-lg btn-google btn-block text-uppercase"><FontAwesomeIcon icon={faGoogle} className="mr-2" /> Sign in with Google</div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
